import { render, staticRenderFns } from "./AgentTeamAllocation.vue?vue&type=template&id=656a386b"
import script from "./AgentTeamAllocation.vue?vue&type=script&lang=js"
export * from "./AgentTeamAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports